// extracted by mini-css-extract-plugin
module.exports = {"heading":"ExpertInsights_heading__CpBn1","sections":"ExpertInsights_sections__8dOV_","chat":"ExpertInsights_chat__Cjzei"};